import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.ReactNode}
 */
const IconSurroundingsMountainComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="m8 3 4 8 5-5 5 15H2L8 3z" fill="none" />
        <path d="M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19" fill="none" />
      </svg>
    </SvgIcon>
  );
};

IconSurroundingsMountainComponent.displayName = 'IconSurroundingsMountain';

const IconSurroundingsMountain = React.memo(IconSurroundingsMountainComponent);

export default IconSurroundingsMountain;
